import Button from '@jetbrains/ring-ui/components/button/button'
import React from 'react'

import {useEditPipelineYAML} from '../../EditPipelinePage.hooks'

import styles from './EditPipelineYamlActions.css'

function EditPipelineYamlActions() {
  const editPipelineYAML = useEditPipelineYAML()

  return editPipelineYAML.yaml != null ? (
    <>
      <Button
        className={styles.button}
        href={`data:text/plain;charset=utf-8,${encodeURIComponent(editPipelineYAML.yaml)}`}
        download="pipeline.yml"
      >
        {'Download'}
      </Button>
      <Button className={styles.button} onClick={editPipelineYAML.copyToClipboardHandler}>
        {'Copy all'}
      </Button>
    </>
  ) : null
}

export default EditPipelineYamlActions
